import React, {Component} from 'react';
import {Spinner} from "../../Spinner";
import {HELP_FACEBOOK_FIXED_ACTIONS, LinkToArticle} from "../../help_center/LinkToArticle";
import {CategorizedActionsSelect} from "../../selects/CategorizedActionsSelect";
import {UpdateItemsInListIcon} from "../../elements/UpdateItemsInList";
import {ChannelLogo} from "../../channels/ChannelLogo";

export class AccountActionsConfiguration extends Component {
    constructor(props) {
        super(props);
        this.handleCompareConversionsWithLastPeriodChange = this.handleCompareConversionsWithLastPeriodChange.bind(this);
        this.handleConversionTypesChange = this.handleConversionTypesChange.bind(this);
        this.handleRefreshListItems = this.handleRefreshListItems.bind(this);
    }

    // handle events

    handleCompareConversionsWithLastPeriodChange(event) {
        this.putCheckBoxChangeToServer(this.compareConversionsWithLastPeriodUrl(), event)
    }

    handleConversionTypesChange(selectedActions) {
        this.props.onChange(selectedActions);
    }

    actionDataMap() {
        return (actionData) => {
            return {name: actionData.description, id: actionData.action_id != null ? actionData.action_id.toString() : null};
        }
    }

    handleRefreshListItems() {
        if(this.props.onRefreshListItems !== undefined)
            this.props.onRefreshListItems();
    }

    // render

    _renderRefreshListItemsIcon(){
        if(this.props.onRefreshListItems === undefined)
            return null;

        return <div className="refresh_list_items_icon">
            <UpdateItemsInListIcon
                message={this.props.messageForRefreshListItemsIconToolbox}
                isBeingSyncedOnDemand={this.props.isUpdatingListItems}
                onClick={this.handleRefreshListItems}
            />
        </div>
    }

    _renderTextWithUserIndication() {
        if (this.props.showTextWithUserIndication === undefined || this.props.showTextWithUserIndication === true)
            return <label key={0}>Seleccionar cuáles eventos te gustaría trackear como Conversiones<LinkToArticle
                article={HELP_FACEBOOK_FIXED_ACTIONS}/></label>
        return null;
    }

    _renderAdAccountHeader() {
        if (this.props.showAdAccountHeader === undefined || this.props.showAdAccountHeader === false)
            return null;

        return <div className={"ad_account-header"}><ChannelLogo hspace={0} vspace={0} channel={this.props.channel}/>{`${this.props.name} (Id: ${this.props.accountId})`}</div>
    }

    _renderConversionsMultiSelect() {
        if (this.props.allActions !== null && this.props.selectedActions !== null) {
            const ret = [this._renderAdAccountHeader(), this._renderTextWithUserIndication(),this._renderRefreshListItemsIcon()];
            if(this.props.selectedActions.length === 0 && !this.props.hasIncludeAllConversionsSetting)
                ret.push(<div className="form-row"><div className="alert alert-warning col-12 pl-2 mb-0" role="alert">No tienes ningún evento seleccionado. Las métricas e indicadores de conversiones no mostrarán ningún valor.</div></div>);

            ret.push(
                    <CategorizedActionsSelect key={1}
                                        items={this.props.allActions}
                                        itemDataMap={this.actionDataMap()}
                                        selectedItemIds={this.props.selectedActions}
                                        onChange={this.handleConversionTypesChange}
                                        hasAllPrimaryConversionsOption={this.props.hasIncludeAllConversionsSetting}
                                        channel={this.props.channel}
                    />);
            return ret;
        } else {
            return <Spinner color="positive"/>
        }
    }

    render() {
        return (
            this._renderConversionsMultiSelect()
        )
    }
}
